export default __webpack_public_path__ + "static/media/vuesax-linear-teacher.d8b6d1df.svg";